import { AxiosError } from 'axios'
import { axiosPost } from 'shared/api/axios'
import displayGenError from 'shared/utils/displayGenError'
import Entity from '../types/Entity'
import displayError from 'shared/utils/displayError'
import nestedSort from './nestedSort'

interface handleIncludeRowProps {
  row: Entity
  url: string
  relationalFieldName: string
  includedRows: Array<Entity>
  excludedRows: Array<Entity>
  setDisableActions: Function
  setIncludedRows: Function
  setExcludedRows: Function
  setShowOverlay: Function
  onAddItem?: (entity: Entity) => boolean
}

const handleIncludeRow = async (props: handleIncludeRowProps): Promise<boolean> => {
  const {
    row,
    url,
    relationalFieldName,
    includedRows,
    excludedRows,
    setDisableActions,
    setIncludedRows,
    setExcludedRows,
    setShowOverlay,
    onAddItem,
  } = props

  if (onAddItem !== undefined) {
    const ret: boolean = onAddItem(row)
    if (ret === false){ 
      return false
    }

    const newIncluded = [...includedRows, row]

    setIncludedRows(newIncluded)

    const filteredExcluded = excludedRows.filter(
      (r) => r[relationalFieldName] !== row[relationalFieldName]
    )

    setExcludedRows(
      nestedSort(
        filteredExcluded,
        newIncluded,
        props.relationalFieldName
      )
    )

    return true
  }

  setDisableActions(true)

  const catchFunc = (err: AxiosError) => {
    const message: string = err.response?.data?.message ?? 'An error has occurred.'
    displayError({
      errorMessage: message,
      setShowOverlay,
    })
  }

  const formData: any = {}
  Object.entries(row).forEach(([key, value]) => {
    if (key.endsWith('_id')) {
      formData[key] = value
    }
  })

  const response = await axiosPost(url, formData, catchFunc)

  setDisableActions(false)

  if (response.status === 201) {
    let includedRow = {
      ...response.data,
      name: row.name,
      active: row.active,
      isRecent: row?.isRecent,
    }

    if('parent_id' in row){
      includedRow.parent_id = row.parent_id
    }

    const newIncluded = [...includedRows, includedRow]
    setIncludedRows(newIncluded)

    const filteredExcluded = excludedRows.filter(
      (r) => r[relationalFieldName] !== includedRow[relationalFieldName]
    )

    setExcludedRows(
      nestedSort(
        filteredExcluded,
        newIncluded,
        props.relationalFieldName
      )
    )

    return true
  } else {
    displayGenError({ setShowOverlay })
  }

  return false
}

export default handleIncludeRow
